import {CSSProperties, FC, ReactElement} from 'react';

import styles from './styles.module.scss';

export const SIDEBAR_WIDTH = '240px';
export const COLLAPSED_SIDEBAR_WIDTH = '72px';

interface Props {
  header: ReactElement;
  sidebar: ReactElement;
  mainContent: ReactElement;
  isSidebarCollapsed?: boolean;
}

export const DashboardLayout: FC<Props> = ({
  header,
  sidebar,
  mainContent,
  isSidebarCollapsed = false,
}) => {
  const style = {
    '--sidebar-width': isSidebarCollapsed
      ? COLLAPSED_SIDEBAR_WIDTH
      : SIDEBAR_WIDTH,
  } as CSSProperties;

  return (
    <div className={styles.container} style={style}>
      <header>{header}</header>
      <aside>{sidebar}</aside>
      <main>{mainContent}</main>
    </div>
  );
};
